import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

// prettier-ignore
export function PrivateRoute(props) { 

  const microapps = window.MICROFRONTENDS_CONFIG;

  return (    
      <Route
        {...props}
        render={(routeProps) => {          
        return (
          (props.user === null || props.session === null) && (
            <Redirect 
              to={{
                pathname: microapps?.routes?.login?.path,
                state: { from: routeProps.location }
              }}
            />
          )
        );
      }}
      />    
  );
}

PrivateRoute.propTypes = {
  accountId: PropTypes.string,
  user: PropTypes.object,
  claims: PropTypes.shape({
    exp: PropTypes.number
  }),
  session: PropTypes.object
};

PrivateRoute.defaultProps = {
  accountId: undefined,
  user: undefined,
  claims: {},
  session: undefined
};

export default PrivateRoute;
